jQuery(document).ready(function ($) {
  // $(".header .navbar-toggle").on("click", function (e) {
  //   $(this).toggleClass("open");
  //   $(this).parents(".header").toggleClass("active");
  // });
  // $(".header .nav-overlay").on("click", this, function (e) {
  //   $(".header .navbar-toggle").trigger("click");
  // });

  // $('.header .search').on('click', this, function (e) {
  //   e.preventDefault();
  //   $('.header').toggleClass('active');
  //   $(this).toggleClass('active');
  //   $('.search-custom').slideToggle();
  // });
  // $('body').on('click', '.item-toggle , .cat-toggle', function (e) {
  //   e.preventDefault();
  //   $(this).toggleClass('active');
  //   $(this).next().toggleClass('active');
  // });

  function mappings() {
    if ($(".header").length) {
      var moveNavLeft = new MappingListener({
        selector: ".header .menu-main",
        mobileWrapper: ".mobile-nav-inner",
        mobileMethod: "appendTo",
        desktopWrapper: ".header .logo",
        desktopMethod: "insertAfter",
        breakpoint: 991.98,
      }).watch();
      var account = new MappingListener({
        selector: ".header .account",
        mobileWrapper: ".mobile-nav-inner",
        mobileMethod: "appendTo",
        desktopWrapper: ".header .cart-toggle",
        desktopMethod: "insertBefore",
        breakpoint: 991.98,
      }).watch();
      var moveNavright = new MappingListener({
        selector: ".header .search-toggle",
        mobileWrapper: ".mobile-nav-inner",
        mobileMethod: "appendTo",
        desktopWrapper: ".header .account",
        desktopMethod: "insertBefore",
        breakpoint: 991.98,
      }).watch();
    }
  }
  // mappings();

  // var swiper_our_works = new Swiper(".list-image-our-work.swiper", {
  //   loop: false,
  //   slidesPerView: 2,
  //   spaceBetween: 30,
  //   navigation: {
  //     clickable: true,
  //     nextEl: ".swiper-next",
  //     prevEl: ".swiper-prev",
  //   },
  //   breakpoints: {
  //     0: { slidesPerView: 1 },
  //     768: { slidesPerView: 2 },
  //     991: { slidesPerView: 2 },
  //   },
  // });
  // var options = {
  //   loop: false,
  //   slidesPerView: 2,
  //   spaceBetween: 30,
  //   navigation: {
  //     clickable: true,
  //     nextEl: ".swiper-next",
  //     prevEl: ".swiper-prev",
  //   },
  //   breakpoints: {
  //     0: { slidesPerView: 1 },
  //     768: { slidesPerView: 2 },
  //     991: { slidesPerView: 2 },
  //   },
  // };
  // swiper_our_works = new Swiper('.list-image-our-work.swiper', options);
  // $(document).on("yith_infs_adding_elem ", function () {
  //   swiper_our_works = new Swiper('.list-image-our-work.swiper', options);
  // });

  // var swiper_clients_home = new Swiper(".testimonials-slide.swiper", {
  //   loop: true,
  //   slidesPerView: 4,
  //   spaceBetween: 70,
  //   // navigation: {
  //   //   clickable: true,
  //   //   nextEl: ".swiper-button-next",
  //   //   prevEl: ".swiper-button-prev",
  //   // },
  //   pagination: {
  //     el: ".swiper-pagination",
  //     clickable: true,
  //   },
  //   breakpoints: {
  //     0: { slidesPerView: 1 },
  //     768: { slidesPerView: 2 },
  //     991: { slidesPerView: 4 },
  //   },
  // });
  // var list_gallery = new Swiper(".list-gallery .swiper", {
  //   loop: true,
  //   slidesPerView: 3,
  //   spaceBetween: 32,
  //   // navigation: {
  //   //   clickable: true,
  //   //   nextEl: ".swiper-button-next",
  //   //   prevEl: ".swiper-button-prev",
  //   // },
  //   pagination: {
  //     el: ".swiper-pagination",
  //     clickable: true,
  //   },
  //   breakpoints: {
  //     0: { slidesPerView: 1 },
  //     768: { slidesPerView: 1 },
  //     991: { slidesPerView: 3 },
  //   },
  // });
  // var list_item_recipes = new Swiper(".list-item-recipes .swiper", {
  //   loop: false,
  //   slidesPerView: 3,
  //   spaceBetween: 32,
  //   // navigation: {
  //   //   clickable: true,
  //   //   nextEl: ".swiper-button-next",
  //   //   prevEl: ".swiper-button-prev",
  //   // },
  //   pagination: {
  //     el: ".swiper-pagination",
  //     clickable: true,
  //   },
  //   breakpoints: {
  //     0: { slidesPerView: 1 },
  //     768: { slidesPerView: 1 },
  //     991: { slidesPerView: 3 },
  //   },
  // });

  // var swiper_slide = new Swiper(".banner-slide-home.swiper", {
  //   loop: true,
  //   autoplay: {
  //     delay: 3000,
  //   },
  //   speed: 1500,
  //   effect: "fade",
  //   fadeEffect: {
  //     crossFade: true,
  //   },
  //   slidesPerView: 1,
  //   spaceBetween: 1,
  //   pagination: {
  //     el: ".swiper-pagination",
  //     clickable: true,
  //   },
  //   navigation: {
  //     clickable: true,
  //     nextEl: ".swiper-button-next",
  //     prevEl: ".swiper-button-prev",
  //   },
  // });

  // var swiper_slide_product_home = new Swiper(".list-item-product .swiper", {
  //   loop: true,
  //   slidesPerView: 1,
  //   spaceBetween: 20,
  //   // pagination: {
  //   //   el: ".swiper-pagination",
  //   //   clickable: true,
  //   //   renderBullet: function (index, className) {
  //   //     return '<span class="' + className + '">' + (index + 1) + "</span>";
  //   //   },
  //   // },
  //   navigation: {
  //     clickable: true,
  //     nextEl: ".swiper-next",
  //     prevEl: ".swiper-prev",
  //   },
  //   breakpoints: {
  //     0: { slidesPerView: 1 },
  //     768: { slidesPerView: 2 },
  //     991: { slidesPerView: 4 },
  //   },
  // });
  // var swiper_slide_product_daily = new Swiper(".list-item-product-daily .swiper", {
  //   loop: true,
  //   slidesPerView: 1,
  //   spaceBetween: 20,
  //   navigation: {
  //     clickable: true,
  //     nextEl: ".swiper-next",
  //     prevEl: ".swiper-prev",
  //   },
  // });

  // Boutique Section Swiper
  var boutiqueSliders = document.querySelectorAll('.boutique-section__slider');
  boutiqueSliders.forEach(function(slider) {
    if (slider) {
      new Swiper(slider, {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 0,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        speed: 1000,
        effect: 'slide',
        pagination: {
          el: slider.querySelector('.swiper-pagination'),
          clickable: true,
        },
        navigation: {
          nextEl: slider.querySelector('.swiper-button-next'),
          prevEl: slider.querySelector('.swiper-button-prev'),
        },
      });
    }
  });

  // Materials Section Swiper
  var materialsSliders = document.querySelectorAll('.materials-section__slider');
  materialsSliders.forEach(function(slider) {
    if (slider) {
      var sliderId = slider.id;
      var sectionId = sliderId.replace('materials-slider-', '');
      
      // Find parent container
      var parentContainer = slider.closest('.materials-section__right');
      if (!parentContainer) {
        parentContainer = slider.parentElement;
      }
      
      var swiperInstance = new Swiper(slider, {
        loop: true,
        slidesPerView: 1.7,
        spaceBetween: 20,
        speed: 600,
        effect: 'slide',
      });

      // Custom navigation buttons - search in parent container
      var prevBtn = parentContainer ? parentContainer.querySelector('.materials-slider-prev-' + sectionId) : document.querySelector('.materials-slider-prev-' + sectionId);
      var nextBtn = parentContainer ? parentContainer.querySelector('.materials-slider-next-' + sectionId) : document.querySelector('.materials-slider-next-' + sectionId);
      
      if (prevBtn) {
        prevBtn.addEventListener('click', function(e) {
          e.preventDefault();
          swiperInstance.slidePrev();
        });
      }
      
      if (nextBtn) {
        nextBtn.addEventListener('click', function(e) {
          e.preventDefault();
          swiperInstance.slideNext();
        });
      }
    }
  });

  // Collection Section Product Sliders
  var collectionProductSliders = document.querySelectorAll('[class*="collection-product-slider-"]');
  collectionProductSliders.forEach(function(slider) {
    if (slider) {
      var productElement = slider.closest('.collection-section__product');
      var pagination = slider.querySelector('.swiper-pagination');
      var nextBtn = slider.querySelector('.swiper-button-next');
      var prevBtn = slider.querySelector('.swiper-button-prev');
      
      // Only initialize if there are multiple slides
      var slides = slider.querySelectorAll('.swiper-slide');
      if (slides.length > 1 && productElement) {
        // Enable loop when there are 2 or more slides
        var enableLoop = slides.length >= 2;
        
        var swiperInstance = new Swiper(slider, {
          loop: enableLoop,
          loopAdditionalSlides: enableLoop ? 2 : 0,
          slidesPerView: 1,
          spaceBetween: 0,
          speed: 600,
          initialSlide: 0, // Always start at first slide
          pagination: pagination ? {
            el: pagination,
            clickable: true,
          } : false,
          navigation: (nextBtn && prevBtn) ? {
            nextEl: nextBtn,
            prevEl: prevBtn,
          } : false,
        });

        // Wait for Swiper to initialize loop if enabled
        if (enableLoop) {
          swiperInstance.on('loopFix', function() {
            // Loop is ready
          });
        }

        // On hover: go to second slide (index 1) immediately
        productElement.addEventListener('mouseenter', function() {
          if (slides.length >= 2) {
            // Ensure we go to the second slide (index 1)
            if (swiperInstance.params.loop) {
              // For loop mode, use slideToLoop to maintain loop integrity
              swiperInstance.slideToLoop(1, 0);
            } else {
              swiperInstance.slideTo(1, 0);
            }
          }
        });

        // On mouse leave: return to first slide
        productElement.addEventListener('mouseleave', function() {
          if (swiperInstance.params.loop) {
            swiperInstance.slideToLoop(0, 600);
          } else {
            swiperInstance.slideTo(0, 600);
          }
        });
      }
    }
  });

  // var swiper = new Swiper(".list-icon-gallery .swiper", {
  //   slidesPerView: 5,
  //   grid: {
  //     rows: 3,
  //     fill: "row",
  //   },
  //   spaceBetween: 0,
  //   pagination: {
  //     el: ".swiper-pagination",
  //     clickable: true,
  //   },
  //   navigation: {
  //     clickable: true,
  //     nextEl: ".swiper-button-next",
  //     prevEl: ".swiper-button-prev",
  //   },
  //   breakpoints: {
  //     0: {
  //       slidesPerView: 2,
  //       grid: {
  //         rows: 2,
  //         fill: "row",
  //       },
  //     },
  //     768: {
  //       slidesPerView: 3,
  //       grid: {
  //         rows: 2,
  //         fill: "row",
  //       },
  //     },
  //     991: {
  //       slidesPerView: 5,
  //       grid: {
  //         rows: 3,
  //         fill: "row",
  //       },
  //     },
  //   },
  // });

  // var e = $(".header");
  // e.length &&
  //   $(window).on("load scroll", function () {
  //     $(window).scrollTop() > 70 ? e.addClass("show") : e.removeClass("show");
  //   });

  // $('.count').each(function () {
  //   if($(this).text().includes('+')){
  //     $(this).prop('Counter',0).animate({
  //       Counter: $(this).text().replace('+','')
  //     }, {
  //         duration: 2000,
  //         easing: 'swing',
  //         step: function (now) {
  //             $(this).text(Math.ceil(now)).append('<span> +</span>');
  //         }
  //     });
  //   }
  //   else{
  //     $(this).prop('Counter',0).animate({
  //       Counter: $(this).text().replace(/[^\d]/g, '')
  //     }, {
  //         duration: 2000,
  //         easing: 'swing',
  //         step: function (now) {
  //             $(this).text(Math.ceil(now));
  //         }
  //     });
  //   }

  // });

  // if ($(".statistics").length) {
  //   var options = {
  //     useEasing: true,
  //     useGrouping: true,
  //     separator: "",
  //     decimal: ".",
  //     prefix: "",
  //     suffix: "",
  //   };
  //   var counts = [];
  //   $(".counter-1").each(function () {
  //     var num = $(this).attr("data-count"); //end count
  //     var nuen = $(this).text();
  //     if (nuen === "") {
  //       nuen = 0;
  //     }
  //     counts.push(new CountUp(this, nuen, num, 0, 3, options));
  //   });
  //   if ($(".statistics").length) {
  //     var waypoint1 = new Waypoint({
  //       element: document.getElementsByClassName("statistics"),
  //       handler: function handler(direction) {
  //         if (direction == "up") {
  //           for (var i = 0; i < counts.length; i++) {
  //             counts[i].reset();
  //           }
  //         } else {
  //           for (var i = 0; i < counts.length; i++) {
  //             counts[i].start();
  //           }
  //         }
  //       },
  //       offset: "80%",
  //     });
  //   }
  // }

  // if (typeof(Storage) !== "undefined") {
  //   if(!sessionStorage.getItem("popup")) {
  //       setTimeout(function () {
  //           $(".sectionPopup").removeClass("hidden").addClass("show");
  //       }, 3000);
  //       sessionStorage.setItem("popup", true);
  //   }
  // }
  // // popup
  // $(".close-popup, .text-close").on("click", function (event) {
  //   event.preventDefault();
  //   $(".sectionPopup").removeClass("show").addClass("hidden");
  // });

  // AOS.init();
  // $(window).scroll(function () {
  //   if ($(this).scrollTop() > 400) {
  //     $("#back-to-top").addClass("active");
  //   } else {
  //     $("#back-to-top").removeClass("active");
  //   }
  // });
  // $("#back-to-top").on("click", function () {
  //   $("html, body").animate({ scrollTop: "0px" }, 800);
  //   return false;
  // });

});
